import { useCallback, useState } from 'react';

import type { SeatHolder } from './memberSeats';

export type SeatActionKind = 'assignCoaches' | 'move' | 'revoke' | 'addCohort' | 'removeCohort';

export type SeatAction = Readonly<{
  kind: SeatActionKind;
  holders: readonly SeatHolder[];
  /** Set where the door was opened from the coaches roster, which ends a coach seat. */
  isCoachSeat: boolean;
}>;

export const useSeatActions = () => {
  const [action, setAction] = useState<SeatAction | null>(null);

  const open = useCallback(
    (kind: SeatActionKind, holders: readonly SeatHolder[], isCoachSeat = false) => {
      setAction({ kind, holders, isCoachSeat });
    },
    [],
  );

  const close = useCallback(() => setAction(null), []);

  return { action, open, close };
};
